/**
 * Ambientes efémeros `pr-N` (#435 PR-1).
 *
 * Guard obrigatório: `pr-` + inteiro 1–99999 + app + `-staging.pratzu.com`
 * (ou Pages `pr-N-admin-staging`). Sem dependência de `domains.ts`.
 */

/**
 * Host canónico de um ambiente `pr-N` sob pratzu.com.
 * Rejeita `pr-0-…`, `pr-abc-…`, `xpr-1-…`, `pr-1.evil.com`, etc.
 */
export const PR_ENV_HOST_RE = /^pr-([1-9][0-9]{0,4})-(api|console|landing)-staging\.pratzu\.com$/

/** Pages do admin por PR (`pr-N-admin-staging` + preview opcional). */
const PR_ENV_ADMIN_PAGES_RE = /^(?:[\w-]+\.)?pr-([1-9][0-9]{0,4})-admin-staging\.pages\.dev$/

export type PrEnvApp = 'api' | 'console' | 'landing'

/** `{ pr, app }` se o host é um `pr-N-*-staging.pratzu.com` válido; senão null. */
export function prEnvOf(host: string): { pr: number; app: PrEnvApp } | null {
  const m = PR_ENV_HOST_RE.exec(host.toLowerCase())
  if (!m) return null
  return { pr: Number(m[1]), app: m[2] as PrEnvApp }
}

/**
 * URL da API do mesmo ambiente `pr-N`, ou null se o host não for pr-N.
 * Cobre hosts `pr-N-*-staging.pratzu.com` e `pr-N-admin-staging.pages.dev`.
 */
export function prEnvApiUrl(host: string): string | null {
  const h = host.toLowerCase()
  const env = prEnvOf(h)
  if (env) return `https://pr-${env.pr}-api-staging.pratzu.com`
  const pages = PR_ENV_ADMIN_PAGES_RE.exec(h)
  if (pages) return `https://pr-${pages[1]}-api-staging.pratzu.com`
  return null
}

/**
 * Origens CORS dos frontends `pr-N` (console/landing + Pages do admin).
 * Só entram em `firstPartyOriginPatterns` / `firstPartyReturnToPatterns` fora
 * de produção (#406). Nunca na lista de produção.
 */
export const PR_ENV_ORIGIN_PATTERNS: RegExp[] = [
  /^https:\/\/pr-[1-9][0-9]{0,4}-(console|landing)-staging\.pratzu\.com$/,
  /^https:\/\/([\w-]+\.)?pr-[1-9][0-9]{0,4}-admin-staging\.pages\.dev$/,
]
